// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"164":"terms","845":"QRcode","957":"privacy"}[chunkId] || chunkId) + "." + {"9":"39eb23fd","164":"622225d9","190":"18744cc0","314":"8fd9924a","405":"1f86d7d4","623":"94e3953f","845":"aa272960","956":"30d0bc47","957":"371e6e45"}[chunkId] + ".css";
};